import React from "react";
import PlaylistItem from "./playlist-item";
import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { Playlist } from "../../types/Playlist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faSave } from "@fortawesome/free-solid-svg-icons";
import { usePlaylistModal } from "../../hooks/usePlaylistModal";
import { modalStyle } from "../modal-style";

const PlaylistModal = () => {
    const {
      playlistModalOpen,
      setPlaylistModalOpen,
      playlists,
      artist,
      album,
      track,
      selectedPlaylistIds,
      handleTrackPlaylistChange,
      handleSave
    } = usePlaylistModal();
        
    return (
      <Modal open={playlistModalOpen}>
        <Box sx={modalStyle}>
          <Stack spacing={1} direction="column">
            <Box>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Add to playlists
              </Typography>
            </Box>
            <Box>
              {track?.name}
            </Box>
            <Box>
              {playlists?.map((playlist: Playlist, index: number) =>
                <PlaylistItem key={`playlist-item-${index}`}
                  playlist={playlist}
                  artist={artist}
                  album={album}
                  track={track}
                  checked={selectedPlaylistIds.includes(playlist.id)}
                  checkboxChange={(checked) => handleTrackPlaylistChange(checked, playlist.id)}
                />
              )}
            </Box>
            <Box display="flex" justifyContent="space-between">
              <Button variant="contained" size="small" onClick={() => setPlaylistModalOpen(false)} color="error">
                <FontAwesomeIcon fontSize="large" color="primary" icon={faCancel} className="icon" />
                Cancel
              </Button>
              <Button variant="contained" size="small" onClick={handleSave} color="primary">
                <FontAwesomeIcon fontSize="large" color="primary" icon={faSave} className="icon" />
                Save
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>
    )
}

export default PlaylistModal;